export const LOADING_ITEM = "LOADING_ITEM";

export const POST_EXPENSE = "POST_EXPENSE";
export const DELETE_EXPENSE = "DELETE_EXPENSE";
export const UPDATE_EXPENSE = "UPDATE_EXPENSE";
export const GET_EXPENSE_LIST = "GET_EXPENSE_LIST";
